import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from "@webs/components-library/theming";

@customElement('webs-product-feature-auto-item')
export class ProductFeatureAutoItem extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,

    css`
    .m-product-feature-auto-item__wrapper{
         padding: 1.45rem 1.3rem 1.3rem 1.4rem;
    }

       .rich-text-container ::slotted(p) {
          line-height: 1.3 !important;
        }


    @media only screen and (min-width: 1175px) {
       ::slotted(p) {
          line-height: 1.5;
        }

       .m-product-feature-auto-item__wrapper {
          cursor: pointer;
          padding: 0;
          padding-left: 1.4rem;
          margin-top: 1.4rem;
          margin-right: 1.6rem;
          overflow: hidden;
      }

      .m-product-feature-auto-item__title {
      }

      .m-product-feature-auto-item__title--text {
        font-size: 1.2rem;
        line-height: 1.3;
        font-weight: var(--font-weight-light);
        color: var(--color-black);
        margin-bottom: 0.4rem;
      }

      .m-product-feature-auto-item__wrapper .content {
        display: none;
      }

      .m-product-feature-auto-item__wrapper.open .content {
        display: block;
      }

      .m-product-feature-auto-item__wrapper.open {
         background-color: #F6F5F4;
         border-radius: 16px;
         padding: 1.45rem 1.3rem 1.3rem 1.4rem;
         position: relative;
      }

      .m-product-feature-auto-item__progress-bar {
        background: black;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        width: 0;
        z-index: 10;
      }

      .open:hover .m-product-feature-auto-item__progress-bar {
         animation-play-state: paused !important;
      }



      .m-product-feature-auto-item__progress-bar-hidden {
        display: none;
      }

    }

    @keyframes load{
    0%{
      width: 0%;
    }

    100%{
        width: 100%;
    }
};
`]

  @property()
  title: string;

  @property({attribute: 'open', type: Boolean})
  isOpen = false;

  @property({attribute: 'transition-duration'})
  transitionDuration = 10;




  protected render(): unknown {
    return html`
      <div class="m-product-feature-auto-item__wrapper ${this.isOpen ? 'open' : ''} m-product-feature-auto-item__wrapper-mobile" part="wrapper">
        <div class="m-product-feature-auto-item__progress-bar ${this.isOpen ? ''
          : 'm-product-feature-auto-item__progress-bar-hidden'}" style="animation: load ${this.transitionDuration}s linear">

        </div>
        <a class="m-product-feature-auto-item__title " href="javascript:;">
          <h5 class="m-product-feature-auto-item__title--text">${this.title}</h5>
        </a>
        <div class="content hidden" >
          <div class="rich-text-container"><slot></slot></div>
        </div>
      </div>

    `
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    document.addEventListener('DOMContentLoaded', evt => {
      this.firstStart()
    });
  }

  firstStart(): void {
    const card: HTMLElement = this.shadowRoot.querySelector('.m-product-feature-auto-item__wrapper.open');
    if (card) {
      card.addEventListener('click',ev => {
        this.actionsForCard();
      });

      this.actionsForCard();
    }
  }

  startActionCard(): void {
    const card: HTMLElement = this.shadowRoot.querySelector('.m-product-feature-auto-item__wrapper');
    if (card) {
      this.actionsForCard();
    }
  }

  actionsForCard(): void {
    const card: HTMLElement = this.shadowRoot.querySelector('.m-product-feature-auto-item__wrapper');
    this.openCard(card)
    if (card.classList.contains('open')) {
      const progressBar: HTMLElement = this.shadowRoot.querySelector('.m-product-feature-auto-item__progress-bar');
       progressBar.addEventListener("animationend", () => {
         progressBar.style.width= '0%'
         this.closeCard();
         this.dispatchEvent(new CustomEvent('next', {bubbles: true, composed: true}))
      });
    }
  }


  closeCard(): void {
    const card: HTMLElement = this.shadowRoot.querySelector('.open');
    if (card) {
      this.isOpen = false;
      card.classList.remove('open');
      this.requestUpdate()
    }

  }

  openCard(card: HTMLElement): void {
    this.isOpen = true;
    card.classList.add('open')
    this.requestUpdate()
  }

}
